import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty, isEqual, intersection } from 'lodash';
import Loading from 'components/Loading';
import EstimatorForm from './components/estimatorForm';
import PayRateHistory from 'components/PayRateHistory';
import { updateEstimator, requestEstimator, navigateBack, listOfRequests,
         requestWorkroomList, showHistoryScreen, addEventToEstimator,
         requestPayRatesList, hideHistoryScreen, requestAllStores } from 'actionCreators';
import { getEstimatorErrors, getEstimatorById, getWorkroomList,
         getPayRateShowHistory, getPayRateCurrentName, getPayRateLoading,
         getPayRateCurrentHistoryList, getRole, getPosition,
         getManageVendorWorkrooms } from '../../../../reducers';
import connectUI from 'redux-ui';

class EstimatorEdit extends Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.updateEstimatorChanges = this.updateEstimatorChanges.bind(this);
    this.handleCancel = () => this.props.navigateBack();
    this.handleTabChange = index => this.props.updateUI('activeTab', index);
    this.closeRateHistory = () => this.props.hideHistoryScreen();
    this.showRateHistory = this.showRateHistory.bind(this);
    this.state = { all_fetched: false, estimatorChanges: {} };
  }

  componentDidMount = () => {
    this.props.updateUI('activeTab', 0);
    this.props.listOfRequests([
      this.props.requestEstimator(this.props.id),
      this.props.requestWorkroomList(),
      this.props.requestAllStores(),
    ]).then(() => this.setState({ all_fetched: true }));
  }

  getAvailabilityChanges = (oa = null, ca = null, oz = [], cz = [], ow = [], cw = []) => {
    const { allStores } = this.props;
    const availabilityChanges = {};
    if (!oa && !ca) return availabilityChanges;
    /* eslint-disable no-nested-ternary */
    const store = oa ? allStores[oa.store_id] : (ca ? allStores[ca.store_id] : null);
    const { workroom_id: workroom, covered_zip_codes: storeZips } = store;
    const number = store.number || null;
    const owHasStore = ow.includes(workroom);
    const cwHasStore = cw.includes(workroom);
    const ozHasZip = intersection(storeZips, oz).length;
    const czHasZip = intersection(storeZips, cz).length;
    if ((!ozHasZip || !owHasStore) && czHasZip && cwHasStore) availabilityChanges[`Store ${number} Availability`] = ['N/A', 'Added'];
    else if ((!czHasZip || !cwHasStore) && ozHasZip && owHasStore) availabilityChanges[`Store ${number} Availability`] = ['Added', 'N/A'];
    else if (owHasStore && cwHasStore && ozHasZip && czHasZip) {
      if (this.didAvailabilityChange(oa, ca, 'morning')) {
        availabilityChanges[`Store ${number}_morning`] = [
          oa ? oa.morning : [], ca ? ca.morning : [],
        ];
      }
      if (this.didAvailabilityChange(oa, ca, 'afternoon')) {
        availabilityChanges[`Store ${number}_afternoon`] = [
          oa ? oa.afternoon : [], ca ? ca.afternoon : [],
        ];
      }
      if (this.didAvailabilityChange(oa, ca, 'evening')) {
        availabilityChanges[`Store ${number}_evening`] = [
          oa ? oa.evening : [], ca ? ca.evening : [],
        ];
      }
    }
    return availabilityChanges;
  }

  didAvailabilityChange = (base, comparator, key) =>
    !base || !comparator || !isEqual(base[key] || [], comparator[key] || []);

  updateEstimatorChanges = (key, value) => {
    const newEstimatorChanges = Object.assign({}, this.state.estimatorChanges);
    newEstimatorChanges[key] = value;
    this.setState({ estimatorChanges: newEstimatorChanges });
  }

  handleKey = (estimator, estimatorChanges, key) => {
    const { originalNumber, originalExpiration, originalLink } = this.props;
    const profileDiff = {};
    let oldVal = 'N/A';
    if (key.includes('badge_')) {
      if (key.includes('number')) oldVal = originalNumber;
      else if (key.includes('expiration')) oldVal = originalExpiration;
      else if (key.includes('link')) oldVal = originalLink;
    } else oldVal = (key === 'workrooms' ? estimator.workrooms : estimator[key]);
    const newVal = estimatorChanges[key];
    if (!isEqual(oldVal, newVal)) profileDiff[key] = [oldVal, newVal];
    return profileDiff;
  }

  createProfileDiff = (
    { availabilities: changedAvailabilities = [],
      covered_zip_codes: changedZips = [],
      user_attributes: { workroom_ids: changedWorkrooms = [] } },
  ) => {
    const { estimatorChanges } = this.state;
    const { estimator, estimator: {
      assignee_availabilities: oldAvailabilities = [],
      covered_zip_codes: oldZips = [],
      workrooms: oldWorkrooms = [],
    } } = this.props;
    let profileDiff = {};
    Object.keys(estimatorChanges).forEach((key) => {
      Object.assign(profileDiff, this.handleKey(estimator, estimatorChanges, key));
    });
    if (changedAvailabilities.length) {
      changedAvailabilities.forEach((ca) => {
        const oldAvailability = oldAvailabilities.map(a => a.assignee_availability)
                                                 .find(oa => oa.store_id === ca.store_id);
        const changes = this.getAvailabilityChanges(
          oldAvailability, ca, oldZips, changedZips, oldWorkrooms, changedWorkrooms,
        );
        if (!isEmpty(changes)) profileDiff = { ...profileDiff, ...changes };
      });
    }
    return profileDiff;
  }

  handleSave = (estimator) => {
    const profileDiff = this.createProfileDiff(estimator);
    const eventProps = {
      name: 'Update Profile',
      kind: 'update_profile',
      data: { updates: profileDiff },
    };
    this.props.updateEstimator(estimator)
    .then(() => (!isEmpty(profileDiff) ?
      this.props.addEventToEstimator(estimator.id, eventProps) : null))
    .then(() => this.props.updateUI('successMessage', 'Changes have been saved'));
  }

  showRateHistory = rate => Promise.all([
    this.props.showHistoryScreen(rate), this.props.requestPayRatesList(this.props.id, rate),
  ]);

  render = () => {
    const { errors, estimator, loading, allWorkrooms, ui, role, originalNumber, originalExpiration,
            originalLink, showHistory, rateName, loadingRateHistory, payRates } = this.props;
    const ready = this.state.all_fetched && allWorkrooms !== null && allWorkrooms !== undefined;
    return (loading || !ready ? <Loading /> : <div>
      <EstimatorForm
        errors={errors}
        onSave={this.handleSave}
        onCancel={this.handleCancel}
        updateDiff={this.updateEstimatorChanges}
        estimator={estimator}
        allWorkrooms={allWorkrooms}
        activeTab={ui.activeTab}
        onTabChange={this.handleTabChange}
        handleRateHistory={this.showRateHistory}
        originalNumber={originalNumber}
        originalExpiration={originalExpiration}
        originalLink={originalLink}
        role={role}
        position={this.props.position}
        mvw={this.props.mvw}
      />
      <PayRateHistory
        showHistory={showHistory}
        rateName={rateName}
        closeHistory={this.closeRateHistory}
        loading={loadingRateHistory}
        payRates={payRates}
      />
    </div>);
  }
}

EstimatorEdit.propTypes = {
  estimator: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  navigateBack: PropTypes.func,
  listOfRequests: PropTypes.func,
  requestWorkroomList: PropTypes.func,
  requestAllStores: PropTypes.func,
  requestEstimator: PropTypes.func,
  updateEstimator: PropTypes.func,
  addEventToEstimator: PropTypes.func,
  updateUI: PropTypes.func,
  allWorkrooms: PropTypes.array,
  errors: PropTypes.object,
  ui: PropTypes.object,
  id: PropTypes.number,
  showHistory: PropTypes.bool,
  loadingRateHistory: PropTypes.bool,
  rateName: PropTypes.string,
  payRates: PropTypes.array,
  showHistoryScreen: PropTypes.func,
  requestPayRatesList: PropTypes.func,
  hideHistoryScreen: PropTypes.func,
  role: PropTypes.string,
  allStores: PropTypes.object,
  originalNumber: PropTypes.string,
  originalExpiration: PropTypes.string,
  originalLink: PropTypes.string,
  position: PropTypes.string,
  mvw: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
  const id = Number(ownProps.params.id);
  const estimator = getEstimatorById(state)(id) || {};
  const loading = !estimator || estimator.loading;
  const { badge = null } = estimator;
  const setBadge = badge || {};
  return {
    id,
    loading,
    estimator,
    allWorkrooms: getWorkroomList(state),
    errors: getEstimatorErrors(state) || {},
    showHistory: getPayRateShowHistory(state),
    loadingRateHistory: getPayRateLoading(state),
    rateName: getPayRateCurrentName(state),
    payRates: getPayRateCurrentHistoryList(state),
    role: getRole(state),
    position: getPosition(state),
    mvw: getManageVendorWorkrooms(state),
    allStores: state.stores.byId,
    originalNumber: setBadge.number || 'N/A',
    originalExpiration: setBadge.expiration || 'N/A',
    originalLink: setBadge.badge_link || 'N/A',
  };
};

export default connectUI()(connect(mapStateToProps, {
  navigateBack,
  updateEstimator,
  requestEstimator,
  listOfRequests,
  requestWorkroomList,
  showHistoryScreen,
  requestPayRatesList,
  hideHistoryScreen,
  addEventToEstimator,
  requestAllStores,
})(EstimatorEdit));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/estimators/estimatorEdit.jsx